export default __webpack_public_path__ + "static/media/Macbook-Pro-Disasssembly-01.727e61b6.jpg";